import styled from '@emotion/styled';
import { sectionStyles } from '../css/styles';
import theme from '../theme';
import { ReactComponent as PlayCircleLine } from '@assets/play-circle-line.svg';
import { ReactComponent as GrandOpen } from '@assets/grand_open.svg';
import { ReactComponent as GetItOn } from '@assets/getItOn.svg';

import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import { forwardRef, useContext, useRef } from 'react';

import { FadeInSection } from '../hooks/FadeInSection';
import { Link } from 'react-router-dom';

//export default function Section1(props) {
const Section1 = forwardRef((props, ref) => {

    const { selectLanguage } = useContext(LangContext);
    const { isMobile, toolbarHeight } = useContext(DeviceContext);    
    const videoRef = useRef(null);      

    //alert(toolbarHeight);

    /*
    useEffect(() => {
        setTimeout(()=>{        
            const video = videoRef.current;
            if (video) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then(_ => {                
                    console.log('성공')              
                }).catch(error => {
                    console.log('실패')              
                    console.error('Video playback failed:', error);
                });
            } 
            }
            return () => {          
            if (video) {
                //console.log('리턴')
                video.pause();
                video.currentTime = 0;
            }
            };
        }, 1000)
    }, []);
    */
   
    const Section1 = styled.section`    
        ${sectionStyles}
        height:1200px;
        //background-image: url('/images/bg/main_bg_2560.png');
        background-size: cover;
        text-align:center;
        margin:auto;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url('/images/bg/scar1.png');
            background-size: cover;
            z-index:2;
            //background-position: center;
            //opacity: 0.5; 
        }

        // ${theme.breakpoints.xl} {
        //     background-size: cover; 
        //     background-position: center center;
        //     background-repeat: no-repeat;
        // }

        ${theme.breakpoints.xl_1920} {                        
            height:900px;
            background-size: cover; 
            background-position: center center;
            background-repeat: no-repeat;

            &::before {
                background-image: url('/images/bg/scar1_1920.png');
            }
        }

        ${theme.breakpoints.xl} {            
            height: calc(100% - ${({ toolbarHeight }) => toolbarHeight}px);
            min-height: 100%;
            min-heght: -webkit-fill-available;

            &::before {                
                background-image: url('');                
            }            
        }        
    `;

    // 검은색 배경 및 dotted
    const Section1Inner = styled.div`                
        ${sectionStyles}        
    `;

    const Section1DottedBg = styled.div`
        width:100%;
        height:100%; 
        background:rgba(0, 0, 0, .3);
        background-image: url('/images/bg/top_bg_2560.png');
        background-size: cover;
        position:absolute;
        top:0;
        left:0;
        z-index:2;
    `;

    const MainContent = styled.div`
        width:;

        background-color:transparent;
        position:absolute;
        z-index:2;
    `;

    const MainContentImg = styled.div`
        margin-bottom: 34px;        

        img{
            height:290px;
        }

        ${theme.breakpoints.xl_1920} {
            img{
                height:200px;
            }
        }

        ${theme.breakpoints.xl} {
            margin-bottom: 16px;

            img{
                height:120px;
            }
        }
    `;    

    const MainContentPlayButton = styled.div`
    
    `;

    const MainContentTitle1 = styled.div`        
        color:#dbd8d7;        
        font-size:2.125rem;
        opacity:0.8;
        margin-bottom:14px;

        ${theme.breakpoints.xl_1920} {
            font-size:30px;
        }

        ${theme.breakpoints.xl} {
            font-size:17px;
            margin: 16px 0 10px 0;
            letter-spacing: -.5px;
        }
    `;
    const MainContentTitle2 = styled.div`
        margin-top: 0px;        
        color: #FFF;
        text-align: center;        
        text-shadow: 0px 0px 95.52px rgba(255, 255, 255, 0.70);        
        font-size: 110px;                

        ${theme.breakpoints.xl_1920} {
            font-size:80px;
        }

        ${theme.breakpoints.xl} {
            text-shadow: 0px 0px 43.409px #FFF;
            font-size:42px;
            margin-bottom:16px;
        }
    `;

    const MainContentTitle3 = styled.div`  
        height: 100px;
        svg{
            height:100%;
            -webkit-filter: drop-shadow( 0px 0px 40px rgba(255, 255, 255, 1));
            filter: drop-shadow( 0px 0px 40px rgba(255, 255, 255, 1));
            
            //-webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
            //filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
        }
        
        ${theme.breakpoints.xl} {
            height: 36px;
            margin-bottom:24px;
            svg{
                height:100%;
            }         
        }
    `;
    const MainContentPreRegiButton = styled.div`        
        // display: flex;
        // width: 520px;
        // height: 100px;        
        // margin: 40px auto 0 auto;
        // justify-content: center;
        // align-items: center;        

        // border-radius: 6px;
        // border: 2px solid #FFF;
        // background: linear-gradient(180deg, #FB8937 0.43%, #D13B0C 100.43%);
        // box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);
        // cursor:pointer;

        // color: #FFF;                
        // font-size: 40px;

        // ${theme.breakpoints.xl_1920} {
        //     width: 460px;
        //     height: 80px;  
        //     font-size:32px;
        // }

        img{
            margin: 40px auto 0 auto;
            width:460px;

            // &:hover{
            //     display:inline-block;
            //     scale: 1.05;
            // }
            
            transition:all 0.2s ease;

            &:active{                
                display:inline-block;
                scale: 1.1;
            }
        }

        ${theme.breakpoints.xl} {
            img{
                margin: auto;
                width:260px;
            }

           
        }
    `;
    const MainContentPoweredBy = styled.div`
        margin:24px 0 26px 0;
        color:#dbd8d7;
        font-size:1.625rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap:16px;

        ${theme.breakpoints.xl_1920} {            
            font-size:22px;
        }

        ${theme.breakpoints.xl} {
            margin:10px 0;
            font-size:12px;
            gap:8px;
        }
    `;

    const PoweredByEmotion = styled.svg`
        
        height:30px;

        ${theme.breakpoints.xl_1920} {            
            height:24px;
        }

        ${theme.breakpoints.xl} {            
            height:16px;
        }
    `;

    const MainButtonBox = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap:12px;
        cursor:pointer;
        //position:absolute;
        //z-index:99;

        ${theme.breakpoints.xl} {            
            gap:8px;
        }
    `;
    const MainDownLoadButton = styled.div`
        img{
            height:60px;
        }

        ${theme.breakpoints.xl_1920} {            
            img{
                height:53px;
            }
        }
        ${theme.breakpoints.xl} {
            img{
                height:32px;
            }
        }
    `;

    const ScarBackground = styled.div`
        width:100%;     
        height:100%;   
        background-image: url('/images/bg/scar1.png');
        background-size:contain;
        background-repeat:no-repeat;
        color:white;

        position:absolute;
        bottom:-20px;
        z-index:1;
    `;

    const VideoContainer = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        opacity: 1;
    `;

    // 비디오 태그 스타일 정의
    const Video = styled.video`
        height: 100%;
        width: 100%;
        object-fit: cover; 
    `;

  return (
    <Section1 ref={ref} toolbarHeight={toolbarHeight} >
        <Section1DottedBg></Section1DottedBg>
        <VideoContainer>
            <Video
                ref={videoRef}
                autoPlay
                loop
                webkit-playsinline="true"
                muted
                playsInline
                preload="auto"                
            >
                {/* playsinline autoplay */}
                <source src="/images/bg/pv_saga.mp4" type="video/mp4" />
                {/* <source src="/images/bg/test.mp4" type="video/mp4" /> */}
                {/* <source src={`/images/bg/MTDZ SAGA_PV_${selectLanguage === '한국어' ? 'KR' : 'EN'}.mp4`} type="video/mp4" /> */}
                {/* <source src="img/video.webm" type="video/webm" /> */}
                Your browser is not supported!
            </Video>
        </VideoContainer>
        
        <Section1Inner>
            <MainContent>
                <FadeInSection>
                    <MainContentImg>
                        <img src="/images/logo/SAGA_Rebranding_BI_big.png" alt="메인 이미지" />
                    </MainContentImg>
                </FadeInSection>
                {isMobile &&
                    <MainContentPlayButton>
                        <Link to={
                            `${selectLanguage === '한국어' 
                  ? 'https://youtu.be/pajtFIFW9JE'
                  : 'https://youtu.be/ocvZkbXv6hI'}`
                            } 
                            target="_blank">
                        <PlayCircleLine/>
                        </Link>
                    </MainContentPlayButton>
                }

                <FadeInSection>
                    <MainContentTitle1>{selectLanguage === '한국어' ? '작지만 치명적인 장난감 드래곤들의 대혈투' : 'Tiny But Deadly: Clash of Toy Dragons'}</MainContentTitle1>
                    {/* <MainContentTitle2>GRAND OPEN</MainContentTitle2> */}
                    <MainContentTitle3>
                        <GrandOpen/>
                    </MainContentTitle3>
                    
                    <Link to="https://play.carv.io/events/4dd51c33-5ab5-5586-ad5c-1e85c0d62380/detail" target='_blank'>
                        <MainContentPreRegiButton>
                            <img src={`/images/icon/pre_regi_button_${selectLanguage === '한국어' ? 'kor' : 'eng' }.png`} alt=""/>{/* {selectLanguage === '한국어' ? '지금 사전예약' : 'PRE-REGISTER NOW'} */}
                        </MainContentPreRegiButton>
                    </Link>
                </FadeInSection>
                <MainContentPoweredBy>
                    <div>Powered By</div>
                    {/* style={isMobile ? {width:'67px'} : {width:'126px'}} */}                    
                    {/* <PoweredBy fill="#dbd8d7" css={svgStyles}/> */}
                    <PoweredByEmotion viewBox="0 0 127 30" fill="#dbd8d7" xmlns="http://www.w3.org/2000/svg">
                        <path d="M78.3266 4.3833H78.2832H67.2344V15.0009V25.6184H78.3266V15.0009H89.3771V4.3833H78.3266Z" fill="current"/>
                        <path d="M53.3439 11.2466L53.3127 11.2167L45.5 3.7395L37.6544 11.2466L29.8105 18.7536L37.6544 26.2607L45.5 18.7536L53.3127 26.2308L61.1566 18.7237L53.3439 11.2466Z" fill="current"/>
                        <path d="M8.04993 7.47832L8.01868 7.50824L0.206055 14.9854L8.04993 22.4925L15.8938 29.9995L23.7377 22.4925L15.8938 14.9854L23.7082 7.50824L15.8626 -0.000488281L8.04993 7.47832Z" fill="current"/>
                        <path d="M126.795 11.2466L118.95 3.7395L111.107 11.2466L103.293 3.76776L95.4492 11.2748L103.293 18.7819L111.107 26.2607L118.953 18.752H118.951L126.795 11.2466Z" fill="current"/>
                    </PoweredByEmotion>
                </MainContentPoweredBy>

                {/* style={isMobile ? {height:'28px'} : {height:'60px'}}
                    style={isMobile ? {height:'28px'} : {height:'60px'}}
                    style={isMobile ? {height:'28px'} : {height:'60px'}} */}
                <MainButtonBox> 
                    <Link to="https://www.marblex.io/en" target="_blank">
                        <GetItOn/>
                    </Link>
                    {/* <MainDownLoadButton>
                        <Link to="https://play.google.com/store/apps/details?id=com.sandboxgame.mtdz" target="_blank">
                            <img src={`/images/logo/playStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="download"/>
                        </Link>                        
                    </MainDownLoadButton>
                    <MainDownLoadButton>
                        <Link to="https://apps.apple.com/kr/app/%EB%A9%94%ED%83%80-%ED%86%A0%EC%9D%B4-%EB%93%9C%EB%9E%98%EA%B3%A4%EC%A6%88-%EC%82%AC%EA%B0%80/id1670309224" target="_blank">
                            <img src={`/images/logo/appStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="download"/>
                        </Link>
                    </MainDownLoadButton>
                    <MainDownLoadButton>
                        <Link to="https://m.onestore.co.kr/osmp/onestore/preReserveGameInfoDetail.omp?eventId=eimdycbogyad1ptz8y516pbscwhdrqjwc3tuncj3gyauoattge5depjsgcaug3jwc3ougp3o&adv_showbi=Y" target="_blank">
                            <img src={`/images/logo/oneStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="download"/>
                        </Link>
                    </MainDownLoadButton> */}
                </MainButtonBox>    
          
            </MainContent>
        </Section1Inner>
        {/* <ScarBackground>이거 왜 안나와</ScarBackground> */}
    </Section1>
  )
});

export default Section1;